import {
    DeactivateActionTypes,
    DeactivateState,
    DeactivateActions,
} from "./deactivate.types";

const INITIAL_STATE: DeactivateState = {
    isDeactivated: false,
    isDeactivating: false,
    deactivateErrorMessage: null,
};

const deactivateReducer = (state: any = INITIAL_STATE, action: DeactivateActions) => {
    switch (action.type) {
        case DeactivateActionTypes.DEACTIVATE_START:
            return {
                ...state,
                isDeactivating: true,
            };
        case DeactivateActionTypes.DEACTIVATE_SUCCESS:
            return {
                ...state,
                isDeactivating: false,
                isDeactivated: action.payload.isDeactivated,
            };
        case DeactivateActionTypes.DEACTIVATE_FAILURE:
            return {
                ...state,
                isDeactivating: false,
                deactivateErrorMessage: action.payload.errorMessage,
            };
        default:
            return state;
    }
};

export default deactivateReducer;
